import React from 'react'
import Svg from './Svg'
export const SvgChevronRight = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M14.034 11.996L4.593 2.555 7.147 0l11.997 11.996L7.143 24 4.59 21.444z" />
  </Svg>
))
SvgChevronRight.isIcon = true
export default SvgChevronRight
